import { BRAND } from "../../constants/brand";
// BlogDetailPage.jsx
import { Row, Col } from "antd";
import bannerImage3 from "../../assets/incubationBg.png";
import MainLayout from "../../components/layout/main-layout";
import styles from "./index.module.scss";
import { ShareArticleButtons } from "../../components/common/share-article-buttons";

const Imprintyoti = () => {
  const title = "{BRAND.product} partners with Yoti on digital ID protection and age verification making Yoti an exclusive and pre requirement to joining {BRAND.domainLabel}."

  return (
    <MainLayout>
      <div className={styles.blogDetailPage}>
        {/* Hero Banner */}
        <div
          className={styles.banner}
          style={{
            background: `url(${bannerImage3}) no-repeat center center/cover`,
          }}
        >
          <h1>
            {title}
          </h1>
        </div>

        {/* Author & Content Layout */}
        <Row gutter={[32, 32]} className={styles.mainContent}>
          {/* Sidebar */}
          <Col xs={24} md={7}>
            <div className={styles.sidebar}>
              <div className={styles.authorBox}>
                <div className={styles.authorInfo}>
                  <h3>Press Releases</h3>
                </div>
              </div>
              <div className={styles.postHeader}>
                <div className={styles.topBorder} />
                <p className={styles.publishDate}>Published on July, 2025</p>
                <h1 className={styles.postTitle}>
                  {title}
                </h1>
              </div>

              <ShareArticleButtons title />

            </div>
          </Col>

          {/* Blog Content */}
          <Col xs={24} md={17}>
            <div className={styles.articleWrapper}>
              <p>
                {BRAND.domainLabel} is pleased to announce that the platform has
                partnered with Yoti for digital ID protection and age
                verification.
              </p>

              <p>
                Starting from 1st July 2025, Yoti will be a mandatory, exclusive
                requirement for all users joining {BRAND.domainLabel}. Yoti's key age
                assurance methods are recognised by Ofcom as highly effective
                for verifying age when accessing age-restricted content online.
                Importantly, Yoti verifies users' ages without collecting any
                personal information, ensuring privacy and security.
              </p>

              <p>
                This partnership ensures that {BRAND.domainLabel} complies fully with
                the latest Ofcom online safety regulations, which require social
                media platforms to implement robust age checks. These measures
                are designed to identify users under 18 and protect them from
                inappropriate content, reinforcing {BRAND.domainLabel}'s commitment to
                a safer, age-appropriate online environment.
              </p>
            </div>
          </Col>
        </Row>
      </div>
    </MainLayout>
  );
};

export default Imprintyoti;
